import { debounce } from "../utilities/debounce";
import { get } from '../utilities/querySelector';

document.addEventListener( 'DOMContentLoaded', () => {
    const arc = document.querySelector( '.page-arc' );
    setArcHeight( arc );
    arc.classList.add( 'ready' );

    window.addEventListener( 'resize', debounce( () => setArcHeight( arc ), 300 ) );

    window.addEventListener( 'beforeunload', () => {
        arc.classList.remove( 'ready' );
    } );
} );


function setArcHeight( arc ) {
    let height;
    const bodyClasses = document.body.classList;

    if ( bodyClasses.contains( 'single-hut' ) ) {
        const firstSection = get( '.media-and-content__content' );
        const computed = firstSection.getBoundingClientRect();
        height = computed.bottom + window.scrollY + window.innerWidth * 0.06 + 16;
    } else if ( bodyClasses.contains( 'single-post' ) ) {
        const firstSection = get( '.single__header' );
        const computed = firstSection.getBoundingClientRect();
        height = computed.bottom + window.scrollY + window.innerWidth * 0.04 + 25;
    } else {
        const firstSection = get( 'main section ' );
        const computed = firstSection.getBoundingClientRect();
        height = computed.bottom + window.scrollY;
    }

    arc.style.height = `${height}px`;
}